import { atom } from "recoil";

const ultimateAtom = atom({
    key: 'ultimate',
    default: null
})

export default ultimateAtom